<template>
  <div class="container mb052">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <RepaymentSimulation :member="true">
      <template #nextBtn>
        <BtnMain class="-main" router-name="mb001">
          会員さま専用サイトトップへ
        </BtnMain>
      </template>
    </RepaymentSimulation>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";

import RepaymentSimulation from "@/components/simulation/RepaymentSimulation";
import BtnMain from "@/components/button/BtnMain";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb052",
  components: {
    BtnMain,
    RepaymentSimulation,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご返済シミュレーション | ご返済",
      description:
        "お客さまに合った毎月のご返済プランがシミュレーションできます。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ご返済シュミレーション",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "ご返済シミュレーション",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
